import { c as _c } from "react/compiler-runtime";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { cloneElement, type ReactElement } from 'react';
type DraggableQuestionProps = {
  id: string;
  children: ReactElement<any>;
  disableDrag?: boolean;
  canEdit: boolean;
};
const DraggableQuestion = t0 => {
  const $ = _c(20);
  const {
    id,
    children,
    disableDrag,
    canEdit
  } = t0;
  const isDragDisabled = !!disableDrag || !canEdit;
  let t1;
  if ($[0] !== id || $[1] !== isDragDisabled) {
    t1 = {
      id,
      disabled: isDragDisabled
    };
    $[0] = id;
    $[1] = isDragDisabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable(t1);
  let t2;
  if ($[3] !== transform) {
    t2 = CSS.Translate.toString(transform);
    $[3] = transform;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = isDragging ? 0.5 : 1;
  const t4 = isDragging ? 1 : undefined;
  let t5;
  if ($[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== transition) {
    t5 = {
      transform: t2,
      transition,
      opacity: t3,
      position: "relative",
      zIndex: t4
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = transition;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = !disableDrag;
  let t7;
  if ($[10] !== attributes || $[11] !== children || $[12] !== isDragDisabled || $[13] !== listeners) {
    t7 = cloneElement(children, isDragDisabled ? {} : {
      dragAttributes: attributes,
      dragListeners: listeners
    });
    $[10] = attributes;
    $[11] = children;
    $[12] = isDragDisabled;
    $[13] = listeners;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== setNodeRef || $[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div ref={setNodeRef} style={t5} data-draggable={t6}>{t7}</div>;
    $[15] = setNodeRef;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
export default DraggableQuestion;